/** The enum Tag. */
export enum UnitTag {
    TAMPERED
}
